<template>
    <div class="how-we-emerged-page">
        <IdSection :title="titleIdSection" :info="infoIdSection" />

        <!-- <section>
            <TextImgVideoSection :useVideo="true" titleColor="yellow" />
        </section> -->

        <!-- <section>
            <TextImgVideoSection :useImg="true" :textFirst="false" titleColor="blue" />
        </section> -->

        <div class="section">
            <div class="container">
                <div class="row">
                    <div class="thinking font-bold font-italic">
                        <div class="content">
                            “Em se tratando de investimento social privado (ISP), muitas histórias existem sobre a transferência de recursos entre financiadores e organizações da sociedade civil, mas pouco se fala sobre como essas parcerias se dão da perspectiva de quem é financiado e menos ainda quando se trata de movimentos sociais e coletivos das periferias”
                        </div>
                    </div>

                    <div class="thinking">
                        <div class="content">
                            “Novas narrativas para o investimento social e acesso a recursos nas periferias.”<br>
                            Artigo GIFE. Cássio Aoqui e Diana Mendes integrantes da Rede Potências Periféricas.
                        </div>
                    </div>

                    <div style="margin-bottom: 24px;" class="more-text">
                        Nunca estamos sozinhos no campo social, há muita gente engajada em mudar realidades, salvar vidas,
                        realizar sonhos, nas periferias e no setor do investimento social privado.<br /><br />
                        A Plataforma Potências Periféricas é um exemplo disso, quando atores sociais de contextos distintos
                        se juntam num match perfeito de conexão o resultado não pode ser outro, se não o começo de uma jornada
                        de aprendizados mútuos e esperança renovada para mudar estruturas injustas.<br /><br />

                        E assim nasce a Plataforma, fruto de 2 anos de esforço conjunto e empenho da
                        <b>Rede Potências Periféricas, Instituto Jatobás, Fundações ABH, Fundação Tide Setubal e ponteAponte</b>,
                        que também contou com o apoio da L9 Estúdio Criativo.<br /><br />

                        O projeto, que já era uma ideia antiga das organizações realizadoras, nasceu a partir de um
                        encontro durante a Rede de Trabalho de Grantmaking do GIFE em dezembro de 2019. De lá para cá,
                        um grupo de trabalho foi criado com atores periféricos juntamente com investidores do campo social.
                        E em 2020 a ideia foi selecionada pelo edital do Fundo BIS.<br /><br />

                        Em 2021 aconteceu o desenvolvimento da Plataforma! Quem ficou à frente dessa tarefa foi uma potência,
                        o Fristtram, nascido na Guiné-Bissau (África) e atualmente residente brasileiro atuando como
                        desenvolvedor em São Paulo/SP. Também contamos com o apoio do Mobi Yabiku Neto, membro da Rede
                        Potências Periféricas para a configuração final do servidor. <br /><br />

                        Os dados sobre organizações e projetos que atuam nas periferias eram descentralizados e, por isso,
                        a Plataforma nasce como uma comunidade relevante de encontros, como base em compatibilidades, entre
                        essas iniciativas e o investimento social privado para criar melhores relações com grantmakers
                        (investidores), além de trazer informações relevantes e transparentes sobre todos e assim criar
                        conexões de confiança e duradouras.<br /><br />
                    </div>

                    <div class="thinking font-bold font-italic">
                        <div class="content">
                            “Como investidora do campo social, tínhamos dificuldade de identificar iniciativas,
                            principalmente as informais, que compõem o ecossistema e estabelecer diálogos com elas. A
                            plataforma torna visível o que era invisível: a imensa potência de atores periféricos!
                            Esperamos que ela aproxime pessoas e iniciativas, facilite conexões e, principalmente,
                            permita que investidores tenham um contato direto com as potências, desenvolvendo relações
                            de confiança e facilitando o investimento social em ações periféricas."
                        </div>
                    </div>

                    <div class="thinking">
                        <div class="content">Marina Fay - Diretora Executiva da Fundação<br />ABH</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IdSection from '@//pages/public/components/landing-page/id-section/IdSection'
import TextImgVideoSection from '@/pages/public/components/landing-page/text-img-video-section/TextImgVideoSection'

export default {
    components: { IdSection, TextImgVideoSection },
    data() {
        return {
            titleIdSection: 'Como surgimos',
            infoIdSection: ``
        }
    }
}
</script>

<style scope src="./HowWeEmergedPage-light-theme.css"></style>
<style scope src="./HowWeEmergedPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/how-we-emerged-page/HowWeEmergedPage.vue